import { Link } from 'react-router-dom'

import { useT } from '../i18n/LocaleProvider'

export function NotFound(): JSX.Element {
  const t = useT()
  return (
    <main>
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.body')}</p>
      <p>
        <Link to="/work">{t('notFound.pool')}</Link>
      </p>
    </main>
  )
}
